export * from './aside.directive';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/directives/aside/index.ts